import * as d3 from 'd3'

export default {

  methods: {

    event_Link(selection, col, st) {

      if (!col.filter) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {
          this.link_Action(col, st) 
        })
    },

    link_Action(col, st_) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: this.rawData[this.keys[d]]}
      })

      let filterString_ = this.filters[col.filter] || ''

      if (st_.json !== 'MCC' && filterString_ == '') {
        filterString_ = `[CAT] = '${st_.name[0]}'`
      } else if (st_.json !== 'MCC') {
        filterString_ = `${this.filters[col.filter]} AND [CAT] = '${st_.name[0]}'`
      }

      console.log(st_.json, dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(st_.json, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },

  } 
}